import React from "react";

//import components
import SidebarContentV2 from "./SidebarContentV2";

const Sidebar = (props: any) => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
        {props.type !== "condensed" ? <SidebarContentV2 /> : <SidebarContentV2 />}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
